webpackJsonp([173384378255071],{

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsesStyled = _styledComponents2.default.section.withConfig({
	  displayName: 'uses__UsesStyled',
	  componentId: 'sc-1cswqr2-0'
	})(['*,*:before,*:after{position:relative;box-sizing:border-box;}sub{font-size:1.2rem;}h3{font-size:1.5rem;font-weight:bold;}h3,strong{a,a:link,a:visited{color:', ';text-decoration:none;}a:hover{text-decoration:underline;}}article{margin-top:2rem;li{line-height:1.5;color:', ';strong{color:', ';margin-right:0.2rem;}}}a,a:link,a:visited{color:', ';text-decoration:none;}a:hover{text-decoration:underline;}details{&,summary{display:inline-block;}}.timeline{margin-top:2rem;padding-left:1rem;border-left:3px solid ', ';}.timeline__entry{margin-bottom:3rem;}.timeline__date{display:inline-block;font-size:0.9rem;font-weight:bold;text-transform:uppercase;letter-spacing:0.05em;color:', ';margin-bottom:0.5rem;}.timeline__archive{display:block;summary{display:block;cursor:pointer;h3{display:inline-block;}}}'], _constants.colors.darkTextColor, _constants.colors.mediaColor, _constants.colors.darkTextColor, _constants.colors.linkColor, _constants.colors.linkColor, _constants.colors.linkColor);
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    UsesStyled,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Uses - Roberto V\xE1zquez Gonz\xE1lez Site' }),
	    _react2.default.createElement(
	      'h2',
	      { className: 'general__pageTitle' },
	      'What do I use?'
	    ),
	    _react2.default.createElement(
	      'sub',
	      null,
	      'This `/uses` page was created inspired by Wes Bos\'',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', rel: 'noopener noreferrer', href: 'https://uses.tech/' },
	        'uses.tech'
	      ),
	      ' ',
	      'and basically, it\'s a place where you can find everything I use as a developer. A lot has changed since the first version (hello, AI agents \uD83D\uDC4B), so instead of rewriting history I\'m keeping this page as a timeline: what I use now, and what I used to use. If you see something on this list that interests you, feel free to reach out to me for more information.',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: '/blog/uses-2026-update' },
	        'Here'
	      ),
	      ' I explain the update a bit more.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'timeline' },
	      _react2.default.createElement(
	        'section',
	        { className: 'timeline__entry', id: 'current' },
	        _react2.default.createElement(
	          'span',
	          { className: 'timeline__date' },
	          '2026 \xB7 Current'
	        ),
	        _react2.default.createElement(
	          'article',
	          { id: 'languages' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#languages' },
	              'Languages'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.typescriptlang.org/' },
	                  'TypeScript'
	                ),
	                ':'
	              ),
	              ' ',
	              'I don\'t write plain JavaScript anymore, TS everywhere: on the frontend and also on the backend with',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', rel: 'noopener noreferrer', href: 'https://nestjs.com/' },
	                'Nest.js'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'CSS:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', rel: 'noopener noreferrer', href: 'https://tailwindcss.com/' },
	                'Tailwind CSS'
	              ),
	              ' ',
	              '(or similar class-name based approaches) or CSS Modules.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'HTML:'
	              ),
	              ' Still mostly JSX these days.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Python & Go:'
	              ),
	              ' Both joined the toolbox in the last years. Java is now just an old friend I rarely visit (no more Apex \uD83D\uDC4B), but honestly, TS for almost everything.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'article',
	          { id: 'frameworks_libraries' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#frameworks_libraries' },
	              'Frameworks / Libraries'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://react.dev/' },
	                  'React'
	                ),
	                ':'
	              ),
	              ' ',
	              'Still to build almost everything:',
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'u',
	                    null,
	                    'Complex UIs'
	                  ),
	                  ' at work, where we have complex MFEs (micro frontends).'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'u',
	                    null,
	                    'SPAs'
	                  ),
	                  ' with',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://vitejs.dev/' },
	                    'Vite'
	                  ),
	                  ' ',
	                  '(create-react-app is gone).'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'u',
	                    null,
	                    'iOS and Android apps'
	                  ),
	                  ' with',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://capacitorjs.com/' },
	                    'Capacitor'
	                  ),
	                  ' ',
	                  'more often, but still some',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://reactnative.dev/' },
	                    'React Native'
	                  ),
	                  '.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'u',
	                    null,
	                    'Webs'
	                  ),
	                  ' with',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://astro.build/' },
	                    'Astro'
	                  ),
	                  ', which is my preference nowadays, although I still maintain sites built with',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.gatsbyjs.com/' },
	                    'Gatsby'
	                  ),
	                  ' ',
	                  'and',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://nextjs.org/' },
	                    'Next.js'
	                  ),
	                  '.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://nodejs.org/' },
	                  'Node.js',
	                  ' '
	                ),
	                '/ Lambdas / Hostings:'
	              ),
	              ' ',
	              'Still a very low friction guy. I have projects living on',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.netlify.com/' },
	                'Netlify'
	              ),
	              ',',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', rel: 'noopener noreferrer', href: 'https://vercel.com/' },
	                'Vercel'
	              ),
	              ',',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', rel: 'noopener noreferrer', href: 'https://firebase.google.com/' },
	                'Firebase'
	              ),
	              ' ',
	              'or',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', rel: 'noopener noreferrer', href: 'https://prismic.io/' },
	                'Prismic'
	              ),
	              ', but most of my new projects have moved to',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.cloudflare.com/' },
	                'Cloudflare'
	              ),
	              ' ',
	              '(Pages, Workers, KV). At work we use AWS for everything.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://svelte.dev/' },
	                  'Svelte'
	                ),
	                ' ',
	                '/',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://vuejs.org/' },
	                  'Vue'
	                ),
	                ':'
	              ),
	              ' ',
	              'Played with both \uD83D\uDC81\u200D\u2642\uFE0F, but mostly React nowadays.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'article',
	          { id: 'editors_ai_agents' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#editors_ai_agents' },
	              'Editors / AI Agents'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://code.visualstudio.com/' },
	                  'Visual Studio Code'
	                ),
	                ':'
	              ),
	              ' ',
	              'Still my ',
	              _react2.default.createElement(
	                'u',
	                null,
	                'main editor'
	              ),
	              ', with Vim, Prettier and Code Spell Checker as essential plugins.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: 'https://www.anthropic.com/claude-code'
	                  },
	                  'Claude Code'
	                ),
	                ' ',
	                '/',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://openai.com/codex/' },
	                  'Codex'
	                ),
	                ' ',
	                '/',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: 'https://github.com/features/copilot'
	                  },
	                  'GitHub Copilot'
	                ),
	                ' ',
	                '/',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://gemini.google.com/' },
	                  'Gemini'
	                ),
	                ':'
	              ),
	              ' ',
	              'The biggest change since the last version of this page. Coding agents are now part of my daily workflow, both at work and on side projects.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://aistudio.google.com/' },
	                  'Google AI Studio'
	                ),
	                ':'
	              ),
	              ' ',
	              'To prototype ideas quickly.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.figma.com/' },
	                  'Figma'
	                ),
	                ' ',
	                '+',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: 'https://www.anthropic.com/news/claude-design-anthropic-labs'
	                  },
	                  'Claude Design'
	                ),
	                ' ',
	                '+',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://stitch.withgoogle.com/' },
	                  'Google Stitch'
	                ),
	                ':'
	              ),
	              ' ',
	              'For prototyping design ideas before writing a single line of code.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'article',
	          { id: 'productivity_software' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#productivity_software' },
	              'Software (Productivity)'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.raycast.com/' },
	                  'Raycast'
	                ),
	                ':'
	              ),
	              ' ',
	              'Replaced Alfred after many good years. Clipboard history, snippets, window management... still one of the main reasons to be so productive with my mac.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.warp.dev/' },
	                  'Warp'
	                ),
	                ':'
	              ),
	              ' ',
	              'My terminal, with agents built in.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.choosyosx.com/' },
	                  'Choosy'
	                ),
	                ':'
	              ),
	              ' ',
	              'Essential to be able to manage all the browsers I use.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: 'https://www.atlassian.com/software/jira'
	                  },
	                  'Jira'
	                ),
	                ':'
	              ),
	              ' ',
	              'The way we manage our teamwork.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://kanbanflow.com/' },
	                  'KanbanFlow'
	                ),
	                ':'
	              ),
	              ' ',
	              'The way I manage everything I have to do with the computer and work with Pomodoros.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: 'https://support.apple.com/en-in/HT205890'
	                  },
	                  'Apple Reminders'
	                ),
	                ' ',
	                '+ Calendar Events:'
	              ),
	              ' ',
	              'Shopping List, events, things to remember to do...'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://slack.com/' },
	                  'Slack'
	                ),
	                ' ',
	                '+',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.zoom.us/' },
	                  'Zoom'
	                ),
	                ' ',
	                '+',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://meet.google.com/' },
	                  'Google Meet'
	                ),
	                ' ',
	                '+',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://gmail.com/' },
	                  'Gmail'
	                ),
	                ':'
	              ),
	              ' ',
	              'Communication is key for success for remote workers \uD83D\uDC68\u200D\uD83D\uDCBB.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: 'https://support.apple.com/en-us/105115'
	                  },
	                  'Apple Passwords'
	                ),
	                ':'
	              ),
	              ' ',
	              'My personal password manager.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.dropbox.com/' },
	                  'Dropbox'
	                ),
	                ' ',
	                '+',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://drive.google.com/' },
	                  'Google Drive'
	                ),
	                ':'
	              ),
	              ' ',
	              'Sharing and automatic backups for my files.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'article',
	          { id: 'hardware_setup' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#hardware_setup' },
	              'Hardware/Setup'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://corkerspace.com' },
	                  'Corker - coworking space'
	                ),
	                ':'
	              ),
	              ' ',
	              '... I co-founded it, so I love to go to our coworking space to work and disconnect at home.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'MacBook Pro 16\':'
	              ),
	              ' Sitting behind the external monitor as a second screen, with external keyboard and mouse. Exactly the same setup both in the home office and at Corker, so switching between them is frictionless.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'iPhone + AirPods:'
	              ),
	              ' You know, the ecosystem.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: 'https://www.akg.com/Headphones/Professional%20Headphones/K240-Studio.html'
	                  },
	                  'AKG K240 Studio'
	                ),
	                ' ',
	                '+ Aune T1 MK2 DAC / Sony WF-1000XM4 / IEMs:'
	              ),
	              ' ',
	              'The AKG + DAC combo is still going strong after all these years.',
	              ' ',
	              _react2.default.createElement(
	                'q',
	                null,
	                'Without music, life would be a mistake.'
	              ),
	              ' - Nietzsche'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: 'https://www.last.fm/user/robertovg24/'
	                  },
	                  'Last.fm'
	                ),
	                ' ',
	                '+',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://music.apple.com/' },
	                  'Apple Music'
	                ),
	                ':'
	              ),
	              ' ',
	              'I still scrobble everything to my',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                {
	                  target: '_blank',
	                  rel: 'noopener noreferrer',
	                  href: 'https://www.last.fm/user/robertovg24/'
	                },
	                'Last.fm profile'
	              ),
	              ' ',
	              'after all these years. After trying all the streaming platforms (Deezer, Tidal, Spotify and Apple Music), I\'ve now completely moved to Apple Music. The main reason is that it lets me mix commercial releases with my own rarities: CDs I\'ve bought of music that isn\'t on any platform, like',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                {
	                  target: '_blank',
	                  rel: 'noopener noreferrer',
	                  href: 'https://www.discogs.com/artist/13678327-Time-Lapse-Consortium'
	                },
	                'Time-Lapse Consortium'
	              ),
	              ' ',
	              '\u2013 Live At The Roxy Theatre, or friends\' CDs from Bandcamp. It also feels like it still lets me easily play full albums, caring to listen to them from beginning to end, as they should be heard. And coming from FLAC, it\'s great that Apple Music not only integrates nicely with the Apple ecosystem but also gives you lossless and spatial audio mixes of new records... with no additional cost \uD83D\uDE42.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: 'https://www.synology.com/en-global/products/series/home'
	                  },
	                  'Synology DS215j'
	                ),
	                ' ',
	                '+',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://c2.synology.com/' },
	                  'C2 Backup'
	                ),
	                ':'
	              ),
	              ' ',
	              'Still my backup for everything.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'timeline__entry', id: 'previous' },
	        _react2.default.createElement(
	          'span',
	          { className: 'timeline__date' },
	          '~2019 \xB7 Previous uses'
	        ),
	        _react2.default.createElement(
	          'details',
	          { className: 'timeline__archive' },
	          _react2.default.createElement(
	            'summary',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Expand to see what I used back then (kept as historical data \uD83D\uDDC4\uFE0F)'
	            )
	          ),
	          _react2.default.createElement(
	            'article',
	            { id: 'languages_2019' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Languages'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'JavaScript (ES6) + Babel:'
	                ),
	                ' I just love it'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'CSS:'
	                ),
	                ' Sometimes still using Vanilla CSS, usually SCSS, styled-components or Styled JSX'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'HTML:'
	                ),
	                ' Mostly JSX these days'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Java/Apex:'
	                ),
	                ' Was my main tool years ago, now just using a bit of',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: 'https://developer.salesforce.com/docs/atlas.en-us.apexcode.meta/apexcode/'
	                  },
	                  'Apex'
	                ),
	                ' ',
	                'at work.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'article',
	            { id: 'frameworks_libraries_2019' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Frameworks / Libraries'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://reactjs.org/' },
	                    'React'
	                  ),
	                  ':'
	                ),
	                ' ',
	                'To build everything:',
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'u',
	                      null,
	                      'SPAs'
	                    ),
	                    ' usually just with',
	                    ' ',
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        target: '_blank',
	                        rel: 'noopener noreferrer',
	                        href: 'https://create-react-app.dev/'
	                      },
	                      'create-react-app'
	                    ),
	                    '.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'u',
	                      null,
	                      'iOS and Android apps'
	                    ),
	                    ' with',
	                    ' ',
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        target: '_blank',
	                        rel: 'noopener noreferrer',
	                        href: 'https://facebook.github.io/react-native/'
	                      },
	                      'React Native'
	                    ),
	                    ' ',
	                    '+',
	                    ' ',
	                    _react2.default.createElement(
	                      'a',
	                      { target: '_blank', rel: 'noopener noreferrer', href: 'https://expo.io/' },
	                      'Expo'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'u',
	                      null,
	                      'Webs'
	                    ),
	                    ' with',
	                    ' ',
	                    _react2.default.createElement(
	                      'a',
	                      { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.gatsbyjs.org/' },
	                      'Gatsby'
	                    ),
	                    ' ',
	                    '(but to be honest, I\'m just using Next.js nowadays...).'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'u',
	                      null,
	                      'Complex webs'
	                    ),
	                    ' with Next, as I can do SSR with Lambda or Node, Static and SSG all with the same framework',
	                    ' ',
	                    _react2.default.createElement(
	                      'a',
	                      { target: '_blank', rel: 'noopener noreferrer', href: 'https://nextjs.org/' },
	                      'Next.js'
	                    ),
	                    '.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://nodejs.org/' },
	                    'Node.js',
	                    ' '
	                  ),
	                  '/ JavaScript\'s Lambda / Hostings:'
	                ),
	                ' ',
	                'When I choose backend technology, I\'m very low friction guy, I love ',
	                _react2.default.createElement(
	                  'u',
	                  null,
	                  'BaaS\'s'
	                ),
	                ' or',
	                ' ',
	                _react2.default.createElement(
	                  'u',
	                  null,
	                  'SaaS\'s'
	                ),
	                ' to focus more on giving value to the product and not on ',
	                _react2.default.createElement(
	                  'u',
	                  null,
	                  'DevOp'
	                ),
	                '. That\'s why I use very conformable, easy and scalable services like',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.netlify.com/' },
	                  'Netlify'
	                ),
	                ',',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://zeit.co/' },
	                  'Now'
	                ),
	                ',',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://firebase.google.com/' },
	                  'Firebase'
	                ),
	                ' ',
	                'or',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://prismic.io/' },
	                  'Prismic'
	                ),
	                '. At work using',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.salesforce.com/' },
	                  'Salesforce'
	                ),
	                ' ',
	                'as backend.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://vuejs.org/' },
	                    'Vue'
	                  ),
	                  ':'
	                ),
	                ' ',
	                'Yes, I also use it from time to time \uD83D\uDC81\u200D\u2642\uFE0F, tried with the SPA, Static & "Progressive" flavours (',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://cli.vuejs.org/' },
	                  'Vue CLI'
	                ),
	                ',',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://gridsome.org/' },
	                  'Gridsome'
	                ),
	                ' ',
	                'and',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener noreferrer', href: 'https://nuxtjs.org/' },
	                  'Nuxt.js'
	                ),
	                ' ',
	                'respectively), but I still prefer to use React 90% of the cases.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'article',
	            { id: 'editors_2019' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Editors'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      target: '_blank',
	                      rel: 'noopener noreferrer',
	                      href: 'https://code.visualstudio.com/insiders/'
	                    },
	                    'Visual Studio Code (Insiders)'
	                  ),
	                  ':'
	                ),
	                ' ',
	                'It\'s my ',
	                _react2.default.createElement(
	                  'u',
	                  null,
	                  'main coding tool'
	                ),
	                ', Vim, Biome and Code Spell Checker are my essential plugins and I sync my configuration using VSCode\'s built-in account synchronization now days.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      target: '_blank',
	                      rel: 'noopener noreferrer',
	                      href: 'https://code.visualstudio.com/'
	                    },
	                    'Visual Studio Code'
	                  ),
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'details',
	                  null,
	                  _react2.default.createElement(
	                    'summary',
	                    null,
	                    '... I use this second instance of VSCode only for ',
	                    _react2.default.createElement(
	                      'u',
	                      null,
	                      'documentation'
	                    ),
	                    '.'
	                  ),
	                  'A separate VSCode window I switch to for writing notes, keeping my "coding" instance clean (both share the same configuration). ',
	                  _react2.default.createElement('br', null),
	                  'I keep two folders (',
	                  _react2.default.createElement(
	                    'u',
	                    null,
	                    'workLog'
	                  ),
	                  ' && ',
	                  _react2.default.createElement(
	                    'u',
	                    null,
	                    'tech notes'
	                  ),
	                  ') in Dropbox: ',
	                  _react2.default.createElement(
	                    'u',
	                    null,
	                    'tech notes'
	                  ),
	                  ' grow over time,',
	                  ' ',
	                  _react2.default.createElement(
	                    'u',
	                    null,
	                    'workLog'
	                  ),
	                  ' are quick drafts in Markdown instead of paper. Everything is indexed by',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      target: '_blank',
	                      rel: 'noopener noreferrer',
	                      href: 'https://support.apple.com/en-us/HT204014'
	                    },
	                    'Spotlight'
	                  ),
	                  ' ',
	                  'and VSCode for free, and I read it on the go with',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      target: '_blank',
	                      rel: 'noopener noreferrer',
	                      href: 'https://apps.apple.com/es/app/mweb-powerful-markdown-app/id1183407767?l=en'
	                    },
	                    'MWeb'
	                  ),
	                  '. ',
	                  _react2.default.createElement('br', null),
	                  'These days there\'s an extra bonus: having this history in plain Markdown makes it super handy to hand over as context to AI agents or tools when I need something done in my own proven style.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      target: '_blank',
	                      rel: 'noopener noreferrer',
	                      href: 'https://www.jetbrains.com/idea/'
	                    },
	                    'IntelliJ IDEA'
	                  ),
	                  ' ',
	                  '+',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      target: '_blank',
	                      rel: 'noopener noreferrer',
	                      href: 'http://www.illuminatedcloud.com/'
	                    },
	                    'Illuminated Cloud'
	                  ),
	                  ':'
	                ),
	                ' ',
	                'It\'s the default way for me to deploy Salesforce, ...when I have to.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://aside.io/' },
	                    'aside.io'
	                  ),
	                  ':'
	                ),
	                ' ',
	                'When I have to do quick changes in a specific Salesforce org. Nice online editor'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.sublimetext.com/' },
	                    'Sublime Editor'
	                  ),
	                  ':'
	                ),
	                ' ',
	                '5 Years back, it was my main editor, then JSX and es6 arrived and we all looked to VSCode great and earlier support. Still using eventually, when I want to save battery or open huge files.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'article',
	            { id: 'productivity_software_2019' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Software (Productivity)'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.alfredapp.com/' },
	                    'Alfred with Power Pack'
	                  ),
	                  ' ',
	                  '+ Clipboard History + Snippets:'
	                ),
	                ' ',
	                'It\'s one of the main reasons to be so productive with my mac.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.getharvest.com/' },
	                    'Harvest'
	                  ),
	                  ':'
	                ),
	                ' ',
	                'Client invoices and as work/project timer counter.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'http://docvariables.com/' },
	                    'Doc Variables'
	                  ),
	                  ' ',
	                  '+',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.hellosign.com/' },
	                    'Hello Sign'
	                  ),
	                  ':'
	                ),
	                ' ',
	                'Coworking Contracts, works like a charm, having the templates prepared.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://www.waveapps.com/' },
	                    'Wave'
	                  ),
	                  ':'
	                ),
	                ' ',
	                'Accounting Software'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'article',
	            { id: 'hardware_setup_2019' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Hardware/Setup'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'MacBook pro 13\''
	                ),
	                ' (2018, four thunderbolt 3 ports, 2,7 ghz i7, 16 gb ram) + BenQ g2400w display 24\': Makes me feel productive in the office and offers the power and flexibility I need.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      target: '_blank',
	                      rel: 'noopener noreferrer',
	                      href: 'https://www.raindesigninc.com/mstand.html'
	                    },
	                    'mstand'
	                  ),
	                  ' ',
	                  '+ UBoard smart 3 ports stand:'
	                ),
	                ' ',
	                'The right position is important.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'iPhone 8 + AirPods:'
	                ),
	                ' You know, the ecosystem.'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-uses-js-8f3ebcbd2895b72de14f.js